import { Icon } from '@iconify/react';
import { useRef, forwardRef, useState } from 'react';


// material
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  Button,
  DialogActions,
  Slide
} from '@mui/material';



/* eslint-disable */
const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});
/* eslint-enable */


export default function ConfirmAlertDialog({openConfirmAlertDialog ,message,title,positiveBtnLable,negativeBtnLable, handleClose,handlePositiveClose,handleNegativeClose,action  }) {



 


  return (
    <>
      <Dialog
        open={openConfirmAlertDialog}
        keepMounted
        sx={{ zIndex: 10000000}}
        maxWidth="sm"
        TransitionComponent={Transition}
        onClose={handleClose}
        aria-describedby="confirm-alert-dialog-desc"
      >
        <DialogTitle>{title}</DialogTitle>
        <DialogContent >
          <DialogContentText id="confirm-alert-dialog-desc" sx={{textAlign:'center'}}>
            {message}
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{mt:3}}>
        <Button variant='outlined' onClick={handleNegativeClose}>{negativeBtnLable}</Button>
          <Button variant='contained'  onClick={()=>handlePositiveClose(action)}>{positiveBtnLable}</Button>
        </DialogActions>
      </Dialog>

    </>
  );
}
